import get from 'lodash/get'

import { CommerceToolsApi } from '@grandvisionhq/commercetools'

interface DiscountedPrice {
  name: string
  amount: number
  type: string
  fractionDigits: number
  validFrom?: CommerceToolsApi.DateTime
  validUntil?: CommerceToolsApi.DateTime
}

export type PriceResult = {
  originalPrice: number
  discountedPrice?: DiscountedPrice
  currency: string
}

export const getPrice = (
  variant: CommerceToolsApi.ProductVariant,
  locale: string = 'en'
): PriceResult | undefined => {
  if (!Array.isArray(variant.prices) || !variant.prices.length) {
    return undefined
  }

  const price = variant.prices[0]
  if (!price.discounted) {
    return {
      originalPrice: price.value.centAmount,
      currency: price.value.currencyCode,
    }
  }

  const discounted = price.discounted
  const validity: Pick<DiscountedPrice, 'validFrom' | 'validUntil'> = {}

  if (!discounted.discount || !discounted.discount.obj) {
    return {
      originalPrice: price.value.centAmount,
      currency: price.value.currencyCode,
    }
  }

  if (discounted.discount && discounted.discount.obj) {
    validity.validFrom = discounted.discount.obj.validFrom
    validity.validUntil = discounted.discount.obj.validUntil
  }

  return {
    originalPrice: price.value.centAmount,
    currency: price.value.currencyCode,
    discountedPrice: {
      name: discounted.discount.obj.name[locale] || discounted.discount.obj.name.en || '',
      amount: discounted.value.centAmount,
      type: discounted.discount.obj.value.type,
      fractionDigits: get(discounted, 'discount.obj.value.money[0].fractionDigits', 0),
      ...validity,
    },
  }
}
